import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 11,
	viewBox: "0 0 14 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.352 0.333313L14 0.822219L7 7.33331L0 0.822219L0.647996 0.333313L7 6.24167L13.352 0.333313Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_37_16)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.352 4L14 4.48891L7 11L0 4.48891L0.647996 4L7 9.90836L13.352 4Z",
				fill: "black"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_37_16",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 8,
				fill: "white",
				transform: "translate(0 3)"
			})
		}) })
	]
});
export default SvgDown;
